module.exports = __webpack_public_path__ + "static/media/good-vibes.120d3837.jpg";